import { isBoolean } from "lodash";

export const stringToBoolean = (str?: any): boolean => {
    if (!str) return false;
    try {
        if (isBoolean(str)) {
            return str;
        } else {
            return str.toLowerCase() === 'true';
        }
    } catch (ex) {
        return false;
    }
}


export function omit<T extends object, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
    const result = { ...obj };
    for (const key of keys) {
        delete result[key];
    }
    return result;
}